//4. Заказы в работе (кол-во ЦО, если Стадия заказа не равно Отменено и Дата оплаты null)
export const isValidWorkOrder = (order): boolean => {
    const stage = order["stage-code"]?.toUpperCase();
    return stage !== 'ОТМЕНЕНО' && !order["prepayment_date"]
}